import { TODAY, TODAY_EOD } from '@/constants';
import {
  AccidentIssueWithCacheAnyoneInjuredEnum,
  DispatchIssueWithCacheTaxiUsedEnum,
  DispatchSummaryCallVolumeEnum,
  LostAndFoundIssueReturnStatusEnum,
} from '@/models/gen/graphql';
import { createPersistentComponentState } from '@/state';
import { customSearchStorage } from '@/state/storage';

export type ServiceIssueFiltersType = {
  startDatetime: string;
  endDatetime: string;
  airportCode?: string[];
  tripServicerIataAirlineCodes?: string[];
  anyoneInjured?: AccidentIssueWithCacheAnyoneInjuredEnum;
  taxiUsed?: DispatchIssueWithCacheTaxiUsedEnum;
  returnStatuses?: LostAndFoundIssueReturnStatusEnum[];
  callVolumes?: DispatchSummaryCallVolumeEnum[];
};

const initDefaultServiceIssueFilters: ServiceIssueFiltersType = {
  startDatetime: TODAY,
  endDatetime: TODAY_EOD,
  airportCode: [],
  tripServicerIataAirlineCodes: [],
  anyoneInjured: null,
  taxiUsed: null,
  returnStatuses: [],
  callVolumes: [],
};

export const useServiceIssueFilters = createPersistentComponentState<ServiceIssueFiltersType>(
  'useServiceIssueFilters',
  initDefaultServiceIssueFilters,
  {
    live: false,
    storage: customSearchStorage,
    reviver: (key: string, value: any) => {
      switch (key) {
        default: {
          return value;
        }
      }
    },
  }
);
